interface NotificationData {
  deviceName: string;
  message: string;
  eventCreatedAt: string;
  eventId: string;
}

export const formatNotificationMessage = (data: NotificationData): string => 
  `[AI Routine] User is receiving an event notification detected by ${data.deviceName} on ${data.eventCreatedAt}.

Video caption: ${data.message}.

Please respond exactly in the format: How would you like to customize your alerts for [video caption]?

When set up preference, a) carefully determine what scene user wants to set preference for, which may be different from the video caption; b) apply to all devices by default unless the user specifies a camera/location.`;